import { render, staticRenderFns } from "./BusinessEdit.vue?vue&type=template&id=dde3ba74&scoped=true"
import script from "./BusinessEdit.vue?vue&type=script&lang=js"
export * from "./BusinessEdit.vue?vue&type=script&lang=js"
import style0 from "./BusinessEdit.vue?vue&type=style&index=0&id=dde3ba74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dde3ba74",
  null
  
)

export default component.exports